<template>
  <div class="w-100 d-flex flex-column card-links-chats mt-1">
    <deal-header-chat
      v-if="deal"
      :title="deal.title"
      :price="deal.price"
    />
    <div class="p-1 w-100">
      <h5 class="mb-2">{{$t('creator.send_link_contents')}}</h5>
      <p class="text-blue cursor-pointer" @click="urls.push({url: '', id: utils.getUniqueIndex()})">{{ $t('creator.addLinkNew') }}</p>

      <b-list-group>
        <b-list-group-item v-for="(i, index) in urls" :key="index" class="p-1 m-0">
          <b-form-group class="m-0">
            <div class="d-flex">
              <b-form-input :state="utils.urlStateExpression(i.url)" id="input-domain" v-model="i.url" placeholder="https://" type="url"></b-form-input>
              <b-button variant="flat-secondary" class="ml-1" :disabled="is_uploading" @click="deletLink(i.id)">
                <feather-icon icon="TrashIcon"></feather-icon>
              </b-button>
            </div>
          </b-form-group>
        </b-list-group-item>
      </b-list-group>

      <div class="d-flex justify-content-end flex-wrap mt-2 actions-buttons">
        <b-button variant="light" :disabled="is_uploading" @click="urls = []">{{$t('creator.cancel')}}</b-button>
        <b-button :disabled="!disabledButton() || urls.length === 0 || is_uploading" class="blue-button" variant="blue-button" @click="uploadUrls()">
          <b-spinner class="spinner-waiting-service" v-if="is_uploading"></b-spinner>
          {{$t('creator.submit')}}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BListGroup,
  BListGroupItem,
  BFormGroup,
  BFormInput,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import utils from '@/libs/utils';
import chat_service from '@/services/chat';


export default {
  name: 'uploadLinksChat',
  components: {
    BListGroup,
    BListGroupItem,
    BFormGroup,
    BFormInput,
    BButton,
    BSpinner,
    DealHeaderChat: () => import('@/views/pages/proposals/chat/dealHeaderChat.vue'),
  },
  props: {
    chat: {
      type: Object,
      required: true,
    },
    chat_deal: {
      type: Object,
      required: true,
    },
    is_legacy: {
      type: Boolean,
      default: true
    },
  },
  created() {
  },
  computed: {
    deal() {
      return this.chat_deal?.deal || null;
    },
    uuid_chat_deal() {
      return this.chat_deal?.uuid || null;
    },
  },
  data() {
    return {
      utils,
      urls: [{url: '', id: utils.getUniqueIndex()}],
      is_uploading: false,
    }
  },
  methods: {
    deletLink(id) {
      this.urls = this.urls.filter((item) => item.id !== id);
    },
    disabledButton() {
      let counter_link = 0;
      this.urls.forEach((link) => {
        if (utils.urlStateExpression(link.url)) counter_link += 1;
      })
      return (counter_link === this.urls.length);
    },
    uploadUrls() {
      this.is_uploading = true;
      const formattedUrls = this.urls.map(i => this.formatUrl(i.url));

      const ws_upload_links = !this.is_legacy ? chat_service.uploadLinksInChatV4(this.uuid_chat_deal, { links: formattedUrls }) : chat_service.uploadLinksInChat(this.chat.uuid, { links: formattedUrls });
      ws_upload_links.then(response => {
        this.is_uploading = false;
        this.$emit('uploaded_contents', response.results);
      }).catch(() => {
        this.is_uploading = false;
      });
    },
    formatUrl(url) {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = `https://${url}`
      }
      if (url.startsWith('http://')) {
        url = url.replace('http://', 'https://');
      }
      return url;
    }


  },
}
</script>

<style scoped>
.info-right {
  border-left: 7px solid #55A6C4;
  background: white;
}
.spinner-waiting-service {
  width: 18px;
  height: 18px;
  margin-right: 0.5em;
}
.card-links-chats {
  width: 100%;
  border: 1px solid #ccccccb0;
  border-radius: 1em;
  background: white;
  overflow: hidden;
}
.actions-buttons {
  gap: 0.75rem;
}
@media (max-width: 576px) {
  .actions-buttons {
    flex-direction: column-reverse;
  }
  .actions-buttons .btn {
    width: 100%;
  }
}
</style>
